import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tabs" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tab = _resolveComponent("Tab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "selector",
      style: _normalizeStyle(
        _ctx.currentElement
          ? `left: ${_ctx.currentElement.offsetLeft}px ; width: ${_ctx.currentElement.clientWidth}px;`
          : ''
      )
    }, null, 4),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createBlock(_component_Tab, {
        key: tab.value,
        tab: tab,
        onClick: ($event: any) => (_ctx.handleTabClick(tab, $event))
      }, null, 8, ["tab", "onClick"]))
    }), 128))
  ]))
}